var _style, _g, _g2, _g3, _g4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIqonKey(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;}\n\t.st1{opacity:0.15;}\n\t.st2{clip-path:url(#SVGID_2_);}\n\t.st3{fill:none;stroke:#000000;stroke-width:0.25;stroke-miterlimit:10;}\n\t.st4{opacity:0.4;}\n\t.st5{clip-path:url(#SVGID_4_);fill:none;stroke:#000000;stroke-width:0.25;stroke-miterlimit:10;}\n\t.st6{clip-path:url(#SVGID_4_);}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "key",
    d: "M19.4,4.6c-2.1-2.1-5.6-2.1-7.8,0c-1.5,1.5-1.9,3.6-1.3,5.5l-7,7C3.1,17.3,3,17.5,3,17.8l0,2.3 C3,20.6,3.5,21,4,21h2.6l0.5-0.5l0.5-2.3l2.3-0.5l0.5-2.3l2.3-0.5l1.3-1.3c1.9,0.6,4,0.1,5.5-1.3C21.5,10.2,21.5,6.8,19.4,4.6z  M17.5,8C16.7,8,16,7.3,16,6.5S16.7,5,17.5,5S19,5.7,19,6.5S18.3,8,17.5,8z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "border"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "grid"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "keylines"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIqonKey);
export default __webpack_public_path__ + "static/media/iqon_key.6e682c17.svg";
export { ForwardRef as ReactComponent };